import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { ProjectorTemplateImageResponse } from './images.models'

@Injectable({
  providedIn: 'root',
})
export class ImagesApiService extends GbApiService {
  uploadTemplateImage(templateUuid: string, image: File): Observable<ProjectorTemplateImageResponse> {
    const url = `projector-templates/${templateUuid}/images/`

    const formData = new FormData()
    formData.append('image', image, image.name)

    return this.post<ProjectorTemplateImageResponse>(url, formData)
  }
}
